import { useEffect, useState } from 'react';
import { completeLoginIfRedirected, currentSession, refreshSession } from './cognito';

// Resolves the console session once on load: finish a Hosted UI redirect if
// present, else use the stored session, else try a refresh. Re-checks on a
// timer so an expiring token is refreshed before it fails a request.
export function useConsoleAuth() {
  const [state, setState] = useState({ ready: false, session: null, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const redirected = await completeLoginIfRedirected();
        const session = redirected || currentSession() || (await refreshSession());
        if (!cancelled) setState({ ready: true, session, error: null });
      } catch (err) {
        if (!cancelled) setState({ ready: true, session: null, error: err?.message || String(err) });
      }
    })();
    const timer = setInterval(async () => {
      if (!currentSession()) {
        const s = await refreshSession();
        if (!cancelled) setState(prev => ({ ...prev, session: s }));
      }
    }, 5 * 60 * 1000);
    return () => { cancelled = true; clearInterval(timer); };
  }, []);

  return state;
}
